import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const AhrefWrapper = styled.a`
  cursor: pointer;
  display: inline-block;
  font-family: ${props => props.theme.fonts.fontfaceRegular};
  font-size: ${props => props.theme.fonts.sizeButton};
  color: ${props =>
    props.active ? props.theme.colors.black : props.theme.colors.xDarkgray};
  transition: color 0.2s ease-in;
  padding: 2px 0;

  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

function Ahref({ onClick, children = null, active = false, href, ...rest }) {
  return (
    <AhrefWrapper
      href={href}
      onClick={onClick}
      active={active}
      // when used without href, behave like a button for a11y
      role={href ? undefined : 'button'}
      tabIndex={href ? undefined : 0}
      {...rest}
    >
      {children}
    </AhrefWrapper>
  );
}

Ahref.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  active: PropTypes.bool,
  href: PropTypes.string
};

export default Ahref;
